import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ButtonOptions {
  tooltip?: string;
  onClick?: () => void;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input()
  icon?: string = '';

  @Input()
  label: string = '';

  @Input()
  tooltip?: string = '';

  @Input()
  disabled?: boolean = false;

  @Output()
  onClick = new EventEmitter<any>();

  constructor() {}

  handleClick() {
    this.onClick.emit();
  }
}
